import React from 'react';
import { useRenderAuthorCallback } from '../utils/renderAuthor';
import { useUserPublicInfo } from '../modules/DB';
export var AuthorWidget = React.memo(function (_a) {
    var userId = _a.userId, _b = _a.watchForChanges, watchForChanges = _b === void 0 ? false : _b;
    var renderAuthor = useRenderAuthorCallback() || defaultRenderAuthor;
    var userInfo = useUserPublicInfo(userId, watchForChanges);
    return userInfo !== undefined ? renderAuthor(userId, userInfo) : React.createElement("span", null);
});
var defaultRenderAuthor = function (userId, user) { return (React.createElement("span", null, (user === null || user === void 0 ? void 0 : user.name) || 'Anonymous')); };
//# sourceMappingURL=AuthorWidget.js.map